import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        // 左侧菜单栏数据
        menuItems: [{
            name: 'home', // 要跳转的路由名称 不是路径
            size: 18, // icon大小
            type: 'md-home', // icon类型
            text: '主页', // 文本内容
        },
        {
            type: 'ios-notifications-outline',
            name: 'msg',
            text: '查看消息',
            hidden: true, // 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
        },
        {
            type: 'md-lock',
            name: 'password',
            hidden: true, // 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
            text: '修改密码'
        },
        {
            type: 'md-person',
            name: 'userinfo',
            hidden: true, // 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
            text: '基本资料',
        },
        {
            name: 'Product', // 要跳转的路由名称 不是路径
            size: 18, // icon大小
            type: 'md-home', // icon类型
            text: '产品管理', // 文本内容
        },
        {
            name: 'TeamManagement', // 要跳转的路由名称 不是路径
            size: 18, // icon大小
            type: 'md-home', // icon类型
            text: '团队管理', // 文本内容
        },
        {
            size: 18, // icon大小
            type: 'md-home', // icon类型
            text: '订单明细', // 文本内容
            children: [{
                name: 'OrderForm',
                type: 'ios-grid',
                text: '我的订单'
            },
            {
                name: 'JuniorOrderForm',
                type: 'ios-grid',
                text: '团队订单'
            }
            ]
        },
        {
            name: 'SettleAccounts', // 要跳转的路由名称 不是路径
            size: 18, // icon大小
            type: 'md-home', // icon类型
            text: '结算中心', // 文本内容
        },

            // {
            //     name: 'Config', // 要跳转的路由名称 不是路径
            //     size: 18, // icon大小
            //     type: 'md-home', // icon类型
            //     text: '设置', // 文本内容
            // },
        ],
    },
    mutations: {
        setMenus(state, items) {
            state.menuItems = [...items]
        },
    }
})

export default store